<template>
  <div id="pageAplicacion">
    <v-container grid-list-xl fluid>
      <!-- dsoto  19-12-2022-->
      <v-container>
        <v-layout>
          <v-flex xs12 md4>
            <v-select
              v-model="periodoValue"
              :items="periodoSelect"
              label="Periodo"
              data-vv-name="listaPeriodos"
            ></v-select>
          </v-flex>

          <v-flex xs12 md4>
            <v-select
              v-model="proveedorValue"
              :items="proveedorSelect"
              label="Proveedor"
              item-text="nombre"
              item-value="code"
            ></v-select>
          </v-flex>

          <v-btn
            fab
            dark
            color="teal"
            title="Filtrar evolucion"
            @click="filter()"
          >
            <v-icon dark>filter_list</v-icon>
          </v-btn>
          <v-btn
            fab
            dark
            color="red darken-4"
            title="Limpiar filtros"
            @click="clear()"
          >
            <v-icon dark>clear_all</v-icon>
          </v-btn>
        </v-layout>
      </v-container>
      <!-- dsoto  19-12-2022-->

      <div v-if="showAlert">
        <alert-empty></alert-empty>
      </div>
      <v-layout row wrap>
        <v-container grid-list-xl fluid>
          <v-layout justify-center>
            <v-flex lg12>
              <v-container>
                <v-layout>
                  <v-flex>
                    <div v-if="loading">
                      <loading></loading>
                    </div>
                    <div>
                      <grafica-torta-reporteria
                        v-for="(graf, indexChart) in pruebas"
                        :key="indexChart"
                        :res="res[indexChart]"
                        :titulo="titleGrafica[indexChart]"
                        :titleIn="titleTest[indexChart]"
                      ></grafica-torta-reporteria>
                    </div>

                    <div v-if="mostrar == 1">
                      <div>
                        <grafica-examinador-reporteria
                          v-if="id == 5"
                          :periodo="periodoValue"
                          :proveedor="proveedorValue"
                        ></grafica-examinador-reporteria>
                      </div>
                      <div>
                        <grafica-supervisores-reporteria
                          v-if="id == 5"
                          :periodo="periodoValue"
                          :proveedor="proveedorValue"
                        ></grafica-supervisores-reporteria>
                      </div>
                      <div>
                        <grafica-ds-reporteria
                          v-if="id == 5"
                          :periodo="periodoValue"
                          :proveedor="proveedorValue"
                        ></grafica-ds-reporteria>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
        </v-container>
      </v-layout>

      <!-- dsoto  19-12-2022-->
      <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <v-btn
          v-if="botonDescarga == true"
          color="primary"
          @click="downloadData()"
          >Descarga</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-container>
  </div>
</template>

<script>
import Material from "vuetify/es5/util/colors";
import axios from "axios";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import Loading from "@/views/ui/Loading.vue";
import { misMixins } from "@/mixins/myMixing.js";
import GraficaTortaReporteria from "@/modules/configuration/reporteria/views/GraficaTortaReporteria.vue";
import GraficaExaminadorReporteria from "@/modules/configuration/reporteria/views/GraficaExaminadorReporteria.vue";
import GraficaSupervisoresReporteria from "@/modules/configuration/reporteria/views/GraficaSupervisoresReporteria.vue";
import GraficaDsReporteria from "@/modules/configuration/reporteria/views/GraficaDsReporteria.vue";

export default {
  components: {
    Loading,
    AlertEmpty,
    GraficaTortaReporteria,
    GraficaExaminadorReporteria,
    GraficaSupervisoresReporteria,
    GraficaDsReporteria,
  },
  mixins: [misMixins],
  data: () => ({
    menu1: false,
    color: Material,
    selectedTab: "tab-1",
    indexChart: 0,
    res: [],
    titleGrafica: [],
    titleTest: [],
    pruebas: [],

    showAlert: false,
    loading: false,

    // 19-12-2022
    periodoSelect: [],
    periodoValue: null,
    proveedorSelect: [],
    proveedorValue: null,
    itemsProveedor: [],
    botonDescarga: false,
    mostrar: 0,
  }),

  computed: {},
  created() {
    this.id = this.$route.params.id;
    this.periodoValue = new Date().getFullYear();
    for (let i = parseInt(2019); i <= parseInt(this.periodoValue); i++) {
      this.periodoSelect.push(i);
    }

    this.proveedores();
    // dsoto 12-12-2022

    this.filter();
  },
  mounted() {},
  methods: {
    filter() {
      //alert(this.id + " ID");

      this.pruebas = [];
      this.mostrar = 0;

      if (this.id == 4) {
        this.loadData();
      } else if (this.id == 5) {
        this.loadDataPersonal();
      }
    },

    async loadData() {
      this.loading = true;
      this.pruebas = [];
      this.botonDescarga = false;
      this.pruebas = await this.loadFilter();
      if (this.pruebas.length > 0) {
        this.botonDescarga = true;
        this.pruebas.forEach((m) => {
          let data = [];
          this.titleTest[this.indexChart] = m.tipo_centro;
          this.titleGrafica[this.indexChart] =
            "Tipo de Centro: " + m.tipo_centro;
          data.push(
            {
              value: m.porcen_aprobado.toFixed(2),
              name: "Aprobado",
            },
            {
              value: m.porcen_pte_aprobacion.toFixed(2),
              name: "Pendiente de Aprobación",
            },
            {
              value: m.porcen_reprobado.toFixed(2),
              name: "Reprobado",
            }
          );

          this.res[this.indexChart] = data;
          this.indexChart += 1;
        });
      } else {
        //this.showAlert=true;
      }
      this.loading = false;
    },
    async loadFilter() {
      if (this.periodoValue != null && this.proveedorValue != null) {
        return await axios
          .get(
            "/reportes/habilitacion/centrosp/" +
              this.periodoValue +
              "/" +
              this.proveedorValue
          )
          .then(function (response) {
            return response.data;
          })

          //dsoto
          .catch((error) => {
            if (error) {
              //this.periodoValue = new Date().getFullYear(); //dsoto
              this.proveedorValue = null;

              console.log(error.response.data);
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
            }
            return [];
          });
      } else {
        return await axios
          .get("/reportes/habilitacion/centros/" + this.periodoValue)
          .then(function (response) {
            return response.data;
          })

          //dsoto
          .catch((error) => {
            if (error) {
              //this.periodoValue = new Date().getFullYear(); //dsoto
              this.proveedorValue = null;
              this.mostrar = 0;

              console.log(error.response.data);
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
            }
            return [];
          });
      }
    },

    async loadDataPersonal() {
      this.botonDescarga = false;
      this.loading = true;
      this.pruebas = [];
      this.pruebas = await this.loadPersonal();
      if (this.pruebas.length > 0) {
        this.mostrar = 1;
        this.botonDescarga = true;
        this.pruebas.forEach((m) => {
          let data = [];
          this.titleGrafica[this.indexChart] = "Personal";
          data.push(
            {
              value: m.porcen_examinadores.toFixed(2),
              name: "Examinadores",
            },
            {
              value: m.porcen_supervisores.toFixed(2),
              name: "Supervisores",
            }
          );

          this.res[this.indexChart] = data;
          this.indexChart += 1;
        });
      } else {
        // this.showAlert=true;
      }
      this.loading = false;
    },
    async loadPersonal() {
      // alert("personal");
      if (this.periodoValue != null && this.proveedorValue != null) {
        return await axios
          .get(
            "/reportes/personalprov/" +
              this.periodoValue +
              "/" +
              this.proveedorValue
          )
          .then(function (response) {
            return response.data;
          })
          //dsoto
          .catch((error) => {
            if (error) {
              //this.periodoValue = new Date().getFullYear(); //dsoto
              this.proveedorValue = null;
              this.mostrar = 0;

              console.log(error.response.data);
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
            }
            return [];
          });
      } else {
        return await axios
          .get("/reportes/personal/" + this.periodoValue)
          .then(function (response) {
            return response.data;
          })
          //dsoto
          .catch((error) => {
            if (error) {
              //this.periodoValue = new Date().getFullYear(); //dsoto
              this.proveedorValue = null;
              this.mostrar = 0;

              console.log(error.response.data);
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
            }
            return [];
          });
      }
    },

    // dsoto 19-12-2022
    async proveedores() {
      this.itemsProveedor = [];
      this.itemsProveedor = await this.loadProveedor();

      if (this.itemsProveedor.length > 0) {
        this.loadProveedorSelect();
      } else {
        this.showAlert = true;
      }
    },

    async loadProveedor() {
      let proceso = "";

      if (this.id == 4 || this.id == 5) {
        proceso = "APLICACION";
      }

      return await axios
        //.get("/proveedores")
        .get("/proveedoresProceso/" + proceso)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    loadProveedorSelect() {
      let niv = [];
      this.itemsProveedor.forEach(function (c) {
        let index = niv.findIndex((x) => x.id == c.id);
        console.log(c.razonSocial);
        console.log(c.id);

        if (index === -1) {
          if (c.id != null && c.id != "") {
            niv.push({ nombre: c.razonSocial, code: c.id });
          }
        }
      });
      this.proveedorSelect = niv;
    },
    // dsoto 19-12-2022
    clear() {
      this.proveedorValue = null;
      this.botonDescarga = false;
      this.periodoValue = new Date().getFullYear();

      this.pruebas = [];
      this.mostrar = 0;
      //this.loadData();
    },

    downloadData() {
      //alert(this.id);

      if (this.id == 5) {
        this.dialogLoading = true;
        let filename = "Reporte_personal.xlsx";

        if (this.proveedorValue == null) {
          this.proveedorValue = 0;
        }

        axios({
          url:
            "/reportes/personalExcel/" +
            this.periodoValue +
            "/" +
            this.proveedorValue,
          method: "GET",
          responseType: "blob",
        })
          .then(function (response) {
            const urle = window.URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = urle;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            return response.data;
          })
          .catch(function (error) {
            console.log(error);
            return [];
          });
      }

      if (this.id == 4) {
        this.dialogLoading = true;
        let filename = "Reporte_Habilitacion_Centros.xlsx";

        if (this.proveedorValue == null) {
          this.proveedorValue = 0;
        }

        axios({
          url:
            "/reportes/centrosExcel/" +
            this.periodoValue +
            "/" +
            this.proveedorValue,
          method: "GET",
          responseType: "blob",
        })
          .then(function (response) {
            const urle = window.URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = urle;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            return response.data;
          })
          .catch(function (error) {
            console.log(error);
            return [];
          });
      }
    },
  },
};
</script>
